var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsermanagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "users-copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-1",
    d: "M4.5,4.33A2.12,2.12,0,0,0,6.58,2.17,2.12,2.12,0,0,0,4.5,0,2.13,2.13,0,0,0,2.42,2.17,2.13,2.13,0,0,0,4.5,4.33Zm0-3.25a1.07,1.07,0,0,1,1,1.09,1.07,1.07,0,0,1-1,1.08,1.07,1.07,0,0,1-1-1.08A1.07,1.07,0,0,1,4.5,1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    className: "cls-1",
    d: "M4.5,5.5A4.42,4.42,0,0,1,9,9.83V11.5a.5.5,0,0,1-.5.5H.5a.5.5,0,0,1-.5-.5V9.83A4.42,4.42,0,0,1,4.5,5.5Zm0,.92a3.06,3.06,0,0,0-3.12,3h0v1.5H7.62V9.42A3.06,3.06,0,0,0,4.5,6.42Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsermanagement);
export default __webpack_public_path__ + "static/media/usermanagement.6873820f7eddf8ae0856e37570a84cf8.svg";
export { ForwardRef as ReactComponent };